import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { defineCustomElement as uilabIconDCE } from '@uilab/icon/components/uilab-icon';
import { defineCustomElement as uilabIconGetDefDCE } from '@uilab/icon/components/uilab-icon-get-def';

if (environment.production) {
  enableProdMode();
}

uilabIconDCE();
uilabIconGetDefDCE();

platformBrowserDynamic().bootstrapModule(AppModule).then(ref => {
  // Ensure Angular destroys itself on hot reloads.
  if (window['ngRef']) {
    window['ngRef'].destroy();
  }
  window['ngRef'] = ref;

  // Otherwise, log the boot error
}).catch(err => console.log(err));
